define(function () {
  'use strict';

  return {
    CUSTOM_CURVE_PREFIX: 'customCurve'
    ,HIDABLE_VIEW_TRANSITION_DURATION: 450
    ,HIDABLE_VIEW_TRANSITION_QUICK_DURATION: 250
    ,NEW_KEYFRAME_MS_INCREASE: 1000
    ,NEW_KEYFRAME_X_INCREASE: 200
    ,UNDO_STACK_LIMIT: 50
    ,MODAL_OPACITY: 0.95
    ,CSS_DURATION_LIMIT: 1000 * 60 * 5
    ,INVALID_CLASS: 'invalid'
  };
});
